import React, { useState, useEffect } from "react";
import successImage from "../../../../assets/Graphics/Success page graphic.svg";
import createTransaction from "../../../../assets/GeneralIcons/initiate_internal_transaction.svg";
import viewDetails from "../../../../assets/ViewIcons/view_details.svg";
import dashboard from "../../../../assets/GeneralIcons/dashboard.svg";
import ContactNumber from "../../../../assets/ContactIcons/contact_number.svg";
import Email from "../../../../assets/MailIcons/Mail.svg";
import createAccount from "../../../../assets/UserProfileIcons/create_new_account.svg";
import { beneSuccessDetail } from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";
import { checkUsertoken } from "../../../../redux/features/login/login";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { Box, Tooltip, tooltipClasses } from "@mui/material";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import IfscCodeMapper from "../../../../components/_utils/IfscLogoMapper";
import "./index.css";
import declineImage from "../../../../assets/RejectIcons/reject_icon_red_with_white_circle.svg";
import checkmark from "../../../../assets/CheckmarksIcons/select_all_with_white_filled_circle.svg";
import {
  beneBankLookUp,
  beneWaitingApproved,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  // unachivedAccount,
  unachivedAccountDetail,
  achivedAccountDetail,
  viewAccountDetail,
  beneLookUp,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import { toast } from "react-toastify";
import DeclinedPopup from "../BeneAcountApproval/DeclinedPopup";
import { getRefreshTokenNew } from "../../../../redux/features/refreshToken/refreshToken";
import { toast_position } from "../../../../redux/features/Settings/Authorization";

const BeneCreateSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const isSuccessErrorData = useSelector(
    (state) => state.beneCreateAccount.isSuccessErrorData
  );
  const [ViewAccountDetails, SetViewAccountDetails] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [deniedId, SetdeniedId] = useState(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [getFreshPanStatus, setGetFreshPanStatus] = useState(false);
  const [getFreshBankStatus, setGetFreshBankStatus] = useState(false);
  const [getCheckerBtnStatus, setGetCheckerBtnStatus] = useState(false);
  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
  });

  useEffect(() => {
    if (isSuccessErrorData == "Request failed with status code 404") {
      navigate("*");
    }
  }, [isSuccessErrorData]);
  const [btnToggle, setBtnToggle] = useState({
    accountDtls: true,
    accountPan: false,
    accountBank: false,
  });

  const { beneLookData, beneLookLoading, verifyPANisLoading } = useSelector(
    (state) => state.verify
  );

  let haveApproved = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });
  let havePending = beneLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending" && val?.id != id;
  });

  const benebankLookData = useSelector(
    (state) => state.beneAllVerification.beneLookData
  );

  let haveBankApproved = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "approved";
  });
  let haveBankPending = benebankLookData?.beneficiary_accounts.find((val) => {
    return val?.approval_status === "pending" && val?.id != id;
  });

  useEffect(() => {
    let panStatus = sessionStorage.getItem("Create BeneAcc Fresh PAN");
    let bankStatus = sessionStorage.getItem("Create BeneAcc Fresh Bank");
    let CheckerBtnStatus = sessionStorage.getItem(
      "Create BeneAcc Approve and Decline status"
    );

    setGetFreshPanStatus(JSON.parse(panStatus));
    setGetFreshBankStatus(JSON.parse(bankStatus));
    setGetCheckerBtnStatus(JSON.parse(CheckerBtnStatus));
  }, [sessionStorage]);

  const {
    viewAccountDetailData,
    viewAccountDetailLoading,
    achivedDataDetail,
    unachivedLoadingDetail,
    achivedLoadingDetail,
    unachivedDataDetail,
  } = useSelector((state) => state.verify);

  const handleBtnToggle = (type) => {
    if (type == "accountDtls") {
      setBtnToggle({
        accountDtls: true,
        accountPan: false,
        accountBank: false,
      });
    } else if (type == "accountPan") {
      setBtnToggle({
        accountDtls: false,
        accountPan: true,
        accountBank: false,
      });
    } else if (type == "accountBank") {
      setBtnToggle({
        accountDtls: false,
        accountPan: false,
        accountBank: true,
      });
    } else {
      setBtnToggle({
        accountDtls: true,
        accountPan: false,
        accountBank: false,
      });
    }
  };

  const handleApprovalDetails = async (id) => {
    dispatch(checkUsertoken());
    const response = await dispatch(beneWaitingApproved(id));
    if (response?.payload?.status === false) {
      // const error_msg = response?.payload?.errors?.beneficiary_account[0];
      let error_msg = "";
      if (response?.payload?.errors?.beneficiary_account?.[0]) {
        error_msg = response.payload.errors.beneficiary_account[0];
      } else if (response?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = response.payload.errors.bank_account_number[0];
      } else {
        error_msg = "An unknown error occurred.";
      }
      if (error_msg === "Beneficiary account already approved") {
        const updatedData = viewAccountDetailData?.beneficiary_accounts.map(
          (item) => {
            if (item.id === id) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "approved" : "pending",
              };
            }
            return item;
          }
        );
        SetViewAccountDetails(updatedData);
        dispatch(checkUsertoken());
        await dispatch(viewAccountDetail({ id }));
      } else {
        const updatedData = viewAccountDetailData?.beneficiary_accounts.map(
          (item) => {
            if (item.id === id) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "pending" : "",
                error_msg,
              };
            }
            return item;
          }
        );

        SetViewAccountDetails(updatedData);
        dispatch(checkUsertoken());
        // await dispatch(viewAccountDetail({ id }));
      }
      toast.error(error_msg, toast_position);
    } else {
      const updatedData = viewAccountDetailData?.beneficiary_accounts.map(
        (item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "approved" : "pending",
            };
          }
          return item;
        }
      );
      SetViewAccountDetails(updatedData);
      dispatch(checkUsertoken());
      await dispatch(viewAccountDetail({ id }));

      toast.success(
        " Beneficiary Account approved successfully ",
        toast_position
      );

      navigate(`/accounts/beneficiary_account/details/${id}`);
      sessionStorage.setItem("Create BeneAcc Approve and Decline status", true);
    }
  };

  const handleDeclinedDetials = (id) => {
    setShowPopup(true);
    SetdeniedId(id);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const updateAllAccounts = (updatedAccounts) => {
    SetViewAccountDetails(updatedAccounts);
  };

  useEffect(() => {
    dispatch(checkUsertoken());
    dispatch(beneSuccessDetail(id));
  }, [dispatch, id]);
  const successDetail = useSelector(
    (state) => state.beneCreateAccount.beneSuccessData
  );

  const viewDetailsHandler = () => {
    navigate(`/accounts/beneficiary_account/details/${id}`);
  };

  const createTxn = () => {
    navigate("/transaction/beneficiary_transaction/create", {
      state: currentAccountDetails,
    });
  };

  const createAccountHandler = () => {
    navigate("/accounts/beneficiary_account/create");
  };

  const dashboardHandler = () => {
    navigate("/accounts/beneficiary/dashboard");
  };

  const beneficiaryAccount = successDetail?.beneficiary_accounts[0] || {};

  useEffect(() => {
    if (beneficiaryAccount) {
      const { id, name, bank_name, bank_acc_no, ifsc_code, category, pan_no } =
        beneficiaryAccount;
      setCurrentAccountDetails({
        id,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
      });
    }
  }, [beneficiaryAccount]);

  useEffect(() => {
    dispatch(checkUsertoken());
    dispatch(beneLookUp({ pan_number: beneficiaryAccount.pan_no }));
    dispatch(
      beneBankLookUp({
        ifsc: beneficiaryAccount.ifsc_code,
        bank_account_no: beneficiaryAccount.bank_acc_no,
      })
    );
  }, [
    beneficiaryAccount.pan_no,
    beneficiaryAccount.ifsc_code,
    beneficiaryAccount.bank_acc_no,
  ]);

  useEffect(() => {
    if (!isLoading && services != null) {
      if (services?.includes("BUAccount") || services?.includes("Admin")) {
        dispatch(checkUsertoken());
      } else {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "BUAccount" },
        });
      }
    }
  }, [services, isLoading]);

  useEffect(() => {
    dispatch(checkUsertoken());
    dispatch(getRefreshTokenNew());
  }, []);

  const getResponsiveWidth = () => {
    if (getFreshPanStatus && getFreshBankStatus) {
      return "statusBoth";
    }
    if (getFreshPanStatus || getFreshBankStatus) {
      return "statusOne";
    }
    return "statusDefault";
  };

  return (
    <div className="min-h-screen bg-[#457549] bene_CreateSuccessMainContainer">
      <div className="flex justify-center bene_CreateSuccessMainContainer_innerDiv">
        {showPopup && (
          <div className="fixed top-0 left-0 w-full h-full bg-custom-backdrop bg-opacity-80 flex items-center justify-center z-[9998]">
            <DeclinedPopup
              type="decline account details"
              onClose={handleClosePopup}
              accountId={deniedId}
              id={id}
              allAccounts={ViewAccountDetails}
              updateAllAccounts={updateAllAccounts}
              pageName="Success page decline account"
            />
          </div>
        )}
        <div className="flex flex-row max-w-screen-lg justify-center bene_createAcc_succ_container">
          <div className="flex-1 pt-[160px] bene_createAcc_succImg_container">
            <div className="flex min-w-screen mx-5 justify-center items-center bg-[#457549]">
              <div className="p-6 bene_createAccsuccesImgDiv flex flex-col items-center justify-center text-center text-white text-2xl">
                <img
                  src={successImage}
                  width={"100%"}
                  height={"100%"}
                  alt=""
                  srcSet=""
                  className="bene_createAccsuccessImg"
                />
                <div className="pt-7 bene_createAccsuccessText">
                  <p className="text-xl">
                    Beneficiary account created successfully <br /> and awaiting
                    approval.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-1 pt-28 pb-2 bene_accountCreationDetails">
            <div
              className="flex flex-col mx-5 bg-white rounded-4xl items-center justify-between bene_accDetailsCard pb-5"
              style={{ height: "510px" }}
            >
              <div className="w-full text-white bg-[#55985C] flex justify-evenly items-center gap-0 toggle-btn-container">
                <div
                  className={`toggle-btn-label ${getResponsiveWidth()}`}
                  style={{
                    width:
                      getFreshPanStatus && getFreshBankStatus
                        ? "130px"
                        : getFreshPanStatus || getFreshBankStatus
                        ? "250px"
                        : "100%",
                    borderTopLeftRadius: "30px",
                    borderTopRightRadius:
                      !getFreshPanStatus && !getFreshBankStatus ? "30px" : "",
                    backgroundColor: btnToggle.accountDtls ? "#55985C" : "",
                    cursor: btnToggle.accountDtls ? "default" : "pointer",
                  }}
                  onClick={() => {
                    handleBtnToggle("accountDtls");
                  }}
                >
                  Account Details
                </div>
                <div
                  className="vertical-line-seperater"
                  style={{
                    display: getFreshPanStatus ? "block" : "none",
                  }}
                >
                  &nbsp;
                </div>
                <div
                  className={`toggle-btn-label ${getResponsiveWidth()}`}
                  style={{
                    backgroundColor: btnToggle.accountPan ? "#55985C" : "",
                    width:
                      getFreshPanStatus && getFreshBankStatus
                        ? "169px"
                        : getFreshPanStatus && !getFreshBankStatus
                        ? "250px"
                        : "100%",
                    borderTopRightRadius: !getFreshBankStatus ? "30px" : "",
                    cursor: btnToggle.accountPan ? "default" : "pointer",
                    display: getFreshPanStatus ? "flex" : "none",
                  }}
                  onClick={() => {
                    handleBtnToggle("accountPan");
                  }}
                >
                  <>
                    Accounts
                    <br />
                    <p>Associated to PAN</p>
                  </>
                </div>
                <div
                  className="vertical-line-seperater"
                  style={{
                    display: getFreshBankStatus ? "block" : "none",
                  }}
                >
                  &nbsp;
                </div>
                <div
                  className={`toggle-btn-label ${getResponsiveWidth()}`}
                  style={{
                    backgroundColor: btnToggle.accountBank ? "#55985C" : "",
                    width:
                      getFreshPanStatus && getFreshBankStatus
                        ? "170px"
                        : !getFreshPanStatus && getFreshBankStatus
                        ? "250px"
                        : "100%",
                    borderTopRightRadius: "30px",
                    cursor: btnToggle.accountBank ? "default" : "pointer",
                    display: getFreshBankStatus ? "flex" : "none",
                  }}
                  onClick={() => {
                    handleBtnToggle("accountBank");
                  }}
                >
                  <>
                    Accounts
                    <br />
                    <p>Associated to Bank</p>
                  </>
                </div>
              </div>
              {btnToggle.accountDtls ? (
                <div
                  className={`w-full flex flex-col gap-2 items-center overflow-auto overflow-x-hidden mb-5 ${
                    services?.find(
                      (service) =>
                        service === "BAAccount" || service === "Admin"
                    ) !== undefined && !getCheckerBtnStatus
                      ? "approve-reject-rights"
                      : "approve-reject-rights-block"
                  }`}
                >
                  <div
                    className={`flex flex-col font-bold ${
                      services?.find(
                        (service) =>
                          service === "BAAccount" || service === "Admin"
                      ) !== undefined && !getCheckerBtnStatus
                        ? ""
                        : "pt-[5px]"
                    } px-7 bene_createAccount_name`}
                  >
                    <div
                      className="text-base text-[#000000] w-full text-center p-[5px] bene_createAccount_nametext"
                      // style={{
                      //   marginTop: beneficiaryAccount?.gstin_detail
                      //     ? "70px"
                      //     : "",
                      // }}
                    >
                      <Tooltip
                        componentsProps={{
                          popper: {
                            sx: {
                              [`& .${tooltipClasses.tooltip}`]: {
                                backgroundColor: (theme) =>
                                  theme.palette.common.black,
                              },
                              [`& .${tooltipClasses.arrow}`]: {
                                color: (theme) => theme.palette.common.black,
                              },
                            },
                          },
                        }}
                        arrow
                        PopperProps={{
                          style: {
                            maxWidth: "none",
                          },
                        }}
                        title={
                          beneficiaryAccount?.name
                            ? beneficiaryAccount?.name?.toLowerCase()
                            : null
                        }
                        placement="bottom-start"
                      >
                        <div
                          className="w-96"
                          style={{
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: " nowrap",
                            textTransform: "capitalize",
                          }}
                        >
                          {beneficiaryAccount?.name
                            ? beneficiaryAccount?.name?.toLowerCase()
                            : null}
                        </div>
                      </Tooltip>
                    </div>
                  </div>

                  <div className="w-full content-center">
                    <div className="ml-[10px] dashedLine"></div>
                  </div>
                  <div className="detailsText">
                    <div
                      className="font-normal text-Font_16 text-Primary_black capitalize text-start bene_createAcc_assignedCategories"
                      style={{
                        whiteSpace: !isExpanded && "nowrap",
                        overflow: !isExpanded && "hidden",
                        textOverflow: !isExpanded && "ellipsis",
                      }}
                      onClick={() => setIsExpanded(!isExpanded)}
                    >
                      {typeof beneficiaryAccount.category === "string"
                        ? beneficiaryAccount.category
                            .split(",")
                            .map((category) => category.trim())
                            .join(" , ")
                        : beneficiaryAccount.category}
                    </div>
                    <div className="text-gray-500 text-xs antialiased">
                      Assigned categories
                    </div>

                    <div className="border-t border-Primary_grey w-full mb-2"></div>
                    <div className="flex flex-col space-y-1 text-left">
                      <div className="text-base text-black antialiased">
                        {beneficiaryAccount?.pan_no}
                      </div>
                      <div className="text-gray-500 text-xs antialiased">
                        PAN number
                      </div>
                    </div>
                    <div className="border-t border-Primary_grey w-full mb-2"></div>
                    <div className="flex flex-col space-y-1 text-left">
                      <div className="text-base text-black antialiased">
                        {formatAccountNumber(beneficiaryAccount?.bank_acc_no)}
                      </div>
                      <div className="text-gray-500 text-xs antialiased">
                        Account number
                      </div>
                    </div>
                    <div className="border-t border-Primary_grey w-full mb-2"></div>
                    <div className="flex flex-row justify-between py-0.5">
                      <div className="flex flex-col space-y-1 text-left w-4/6">
                        <div className="text-base text-black antialiased">
                          {beneficiaryAccount?.ifsc_code}
                        </div>
                        <div className="text-gray-500 text-xs antialiased">
                          IFSC code
                        </div>
                      </div>
                      <div className="flex flex-row justify-end w-2/6 h-5 mt-3">
                        <img
                          src={require("../../../../assets/IfscLogo/" +
                            IfscCodeMapper(beneficiaryAccount?.ifsc_code))}
                          alt="bank"
                        />
                      </div>
                    </div>
                    <div className="border-t border-Primary_grey w-full mb-2"></div>
                    <div className="flex flex-row justify-between py-0.5">
                      <div className="flex flex-col space-y-1 text-left w-4/6">
                        <div className="text-base text-black antialiased">
                          +91&nbsp;{beneficiaryAccount?.contact_no}
                        </div>
                        <div className="text-gray-500 text-xs antialiased">
                          Contact number
                        </div>
                      </div>
                      <div className="flex flex-row justify-end w-2/6 h-5 mt-3">
                        <img src={ContactNumber} alt="Contact Number" />
                      </div>
                    </div>
                    <div className="border-t border-Primary_grey w-full mb-2"></div>
                    <div className="flex flex-row justify-between py-0.5">
                      <div className="flex flex-col space-y-1 text-left w-4/5">
                        <Tooltip
                          componentsProps={{
                            popper: {
                              sx: {
                                [`& .${tooltipClasses.tooltip}`]: {
                                  backgroundColor: (theme) =>
                                    theme.palette.common.black,
                                },
                                [`& .${tooltipClasses.arrow}`]: {
                                  color: (theme) => theme.palette.common.black,
                                },
                              },
                            },
                          }}
                          title={beneficiaryAccount?.email_id}
                          arrow
                          placement="bottom"
                          PopperProps={{
                            style: {
                              maxWidth: "none",
                            },
                          }}
                        >
                          <div
                            id="crt-bene-acc-email-id-firstLetter"
                            className="text-base font-medium text-black antialiased"
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                          >
                            {beneficiaryAccount?.email_id?.toLowerCase()}
                          </div>
                        </Tooltip>

                        <div className="text-gray-500 text-xs antialiased">
                          Email ID
                        </div>
                      </div>
                      <div className="flex flex-row justify-end w-1/5 h-5 mt-3">
                        <img src={Email} alt="Email" />
                      </div>
                    </div>
                    {beneficiaryAccount?.gstin_detail && (
                      <>
                        <div className="border-t border-Primary_grey w-full mb-2"></div>
                        <div className="flex flex-row justify-between py-0.5">
                          <div className="flex flex-col space-y-1 text-left w-4/6">
                            <div className="text-base text-black antialiased">
                              {beneficiaryAccount.gstin_detail}
                            </div>
                            <div className="text-gray-500 text-xs antialiased">
                              GSTIN (optional)
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              ) : null}
              {btnToggle.accountPan ? (
                <>
                  {getFreshPanStatus ? (
                    <div
                      className="pan-section-container overflow-y-auto mb-5"
                      style={{
                        width: getFreshBankStatus ? "468px" : "500px",
                        flex: "auto",
                      }}
                    >
                      {haveApproved && (
                        <>
                          <p className="text-[#000000] text-sm font-semibold bg-[#DADADA] mt-4 mb-2 px-8 py-0.5 accountType">
                            Approved accounts
                          </p>
                          <div className="flex flex-col w-full px-8 accountsData pt-1">
                            {beneLookData?.beneficiary_accounts.map(
                              (val, index) => {
                                if (val?.approval_status === "approved") {
                                  return (
                                    <>
                                      <div
                                        key={index}
                                        className="group flex flex-col drop-shadow-xl pb-2 overflow-hidden"
                                      >
                                        <div
                                          className="w-4/5 antialiased truncate text-[#000000] text-sm font-semibold"
                                          style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          <Tooltip
                                            componentsProps={{
                                              popper: {
                                                sx: {
                                                  [`& .${tooltipClasses.tooltip}`]:
                                                    {
                                                      backgroundColor: (
                                                        theme
                                                      ) =>
                                                        theme.palette.common
                                                          .black,
                                                    },
                                                  [`& .${tooltipClasses.arrow}`]:
                                                    {
                                                      color: (theme) =>
                                                        theme.palette.common
                                                          .black,
                                                    },
                                                },
                                              },
                                            }}
                                            arrow
                                            PopperProps={{
                                              style: {
                                                maxWidth: "none",
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            title={val?.name?.toLowerCase()}
                                            placement="bottom-start"
                                          >
                                            {val?.name?.toLowerCase()}
                                          </Tooltip>
                                        </div>
                                        <div className="flex flex-row justify-between">
                                          <div className="flex flex-col space-y-1 text-left">
                                            <div className="text-base text-black antialiased">
                                              {formatAccountNumber(
                                                val.bank_acc_no
                                              )}
                                              <br />
                                              <span className="text-xs text-[#828282]">
                                                Bank account number
                                              </span>
                                            </div>
                                          </div>
                                          <div className="flex flex-row justify-end w-2/6 h-4">
                                            <img
                                              src={require("../../../../assets/IfscLogo/" +
                                                IfscCodeMapper(val?.ifsc_code))}
                                              alt="bank"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="border-t border-Primary_grey w-full mb-2"></div>
                                    </>
                                  );
                                }
                                return null;
                              }
                            )}
                          </div>
                        </>
                      )}
                      {havePending && (
                        <>
                          <p className="text-[#000000] text-sm font-semibold bg-[#DADADA] mt-2 px-8 py-0.5 accountType">
                            Pending accounts
                          </p>
                          <div className="flex flex-col w-full px-8 mt-3 accountsData">
                            {beneLookData?.beneficiary_accounts
                              .filter((fil) => {
                                return fil?.id != id;
                              })
                              .map((val, index) => {
                                if (val?.approval_status === "pending") {
                                  return (
                                    <>
                                      <div
                                        key={index}
                                        className="group flex flex-col drop-shadow-xl pb-2 overflow-hidden"
                                      >
                                        <div
                                          className="w-4/5 antialiased truncate text-[#000000] text-sm font-semibold"
                                          style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          <Tooltip
                                            componentsProps={{
                                              popper: {
                                                sx: {
                                                  [`& .${tooltipClasses.tooltip}`]:
                                                    {
                                                      backgroundColor: (
                                                        theme
                                                      ) =>
                                                        theme.palette.common
                                                          .black,
                                                    },
                                                  [`& .${tooltipClasses.arrow}`]:
                                                    {
                                                      color: (theme) =>
                                                        theme.palette.common
                                                          .black,
                                                    },
                                                },
                                              },
                                            }}
                                            arrow
                                            PopperProps={{
                                              style: {
                                                maxWidth: "none",
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            title={val?.name?.toLowerCase()}
                                            placement="bottom-start"
                                          >
                                            {val?.name?.toLowerCase()}
                                          </Tooltip>
                                        </div>
                                        <div className="flex flex-row justify-between">
                                          <div className="flex flex-col space-y-1 text-left">
                                            <div className="text-base text-black antialiased">
                                              {formatAccountNumber(
                                                val.bank_acc_no
                                              )}
                                              <br />
                                              <span className="text-xs text-[#828282]">
                                                Bank account number
                                              </span>
                                            </div>
                                          </div>
                                          <div className="flex flex-row justify-end w-2/6 h-4">
                                            <img
                                              src={require("../../../../assets/IfscLogo/" +
                                                IfscCodeMapper(val?.ifsc_code))}
                                              alt="bank"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                      <div className="border-t border-Primary_grey w-full mb-2"></div>
                                    </>
                                  );
                                }
                                return null;
                              })}
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <div className="w-full h-full flex flex-col justify-center items-center gap-5 text-center overflow-hidden">
                      <div className="w-[40%] flex flex-row justify-center">
                        <img className="max-w-[145%] pt-5" alt="NoDataImg" />
                      </div>
                      <div className="text-white text-lg antialiased">
                        <p>
                          No associated accounts found for the PAN details
                          provided
                          <br />
                          <span className="text-xs">
                            There are no existing accounts that are associated
                            with the PAN details provided.
                          </span>
                        </p>
                      </div>
                    </div>
                  )}
                </>
              ) : null}
              {btnToggle.accountBank ? (
                <>
                  {getFreshBankStatus ? (
                    <div
                      className="pan-section-container overflow-y-auto"
                      style={{
                        width: getFreshPanStatus ? "468px" : "500px",
                        flex: "auto",
                      }}
                    >
                      {haveBankApproved && (
                        <>
                          <p className="text-[#000000] text-sm font-semibold bg-[#DADADA] mt-4 mb-2 px-8 py-0.5 accountType">
                            Approved accounts
                          </p>
                          <div className="flex flex-col w-full px-8 accountsData">
                            {benebankLookData?.beneficiary_accounts.map(
                              (val, index, array) => {
                                if (val?.approval_status === "approved") {
                                  return (
                                    <>
                                      <div
                                        key={index}
                                        className="group flex flex-col drop-shadow-xl overflow-hidden"
                                      >
                                        <div
                                          className="w-4/5 antialiased truncate text-[#000000] text-sm font-semibold"
                                          style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          <Tooltip
                                            componentsProps={{
                                              popper: {
                                                sx: {
                                                  [`& .${tooltipClasses.tooltip}`]:
                                                    {
                                                      backgroundColor: (
                                                        theme
                                                      ) =>
                                                        theme.palette.common
                                                          .black,
                                                    },
                                                  [`& .${tooltipClasses.arrow}`]:
                                                    {
                                                      color: (theme) =>
                                                        theme.palette.common
                                                          .black,
                                                    },
                                                },
                                              },
                                            }}
                                            arrow
                                            PopperProps={{
                                              style: {
                                                maxWidth: "none",
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            title={val.name}
                                            placement="bottom-start"
                                          >
                                            {val.name
                                              ? val?.name?.toLowerCase()
                                              : ""}
                                          </Tooltip>
                                        </div>
                                        <div className="flex flex-row justify-between">
                                          <div className="flex flex-col space-y-1 text-left">
                                            <div className="text-base text-black antialiased">
                                              {val.pan_no}
                                              <br />
                                              <span className="text-xs text-[#828282]">
                                                PAN number
                                              </span>
                                            </div>
                                          </div>{" "}
                                          <div className="flex flex-row justify-end w-2/6 h-4">
                                            {/* <img
                                          src={require("../../../../assets/Banks/" +
                                            bankLogoMapper(val?.bank_name) +
                                            ".png")}
                                          alt="bank"
                                        /> */}
                                          </div>
                                        </div>
                                      </div>
                                      {index !== array.length - 1 && (
                                        <div className="border-t border-Primary_grey w-full mb-2"></div>
                                      )}
                                    </>
                                  );
                                }
                                return null;
                              }
                            )}
                          </div>
                        </>
                      )}
                      {haveBankPending && (
                        <>
                          <p className="text-[#000000] text-sm font-semibold bg-[#DADADA] mt-2 px-8 py-0.5 accountType">
                            Pending accounts
                          </p>
                          <div className="flex flex-col w-full px-8 mt-3 accountsData">
                            {benebankLookData?.beneficiary_accounts
                              .filter((val) => val?.id != id)
                              .map((val, index, array) => {
                                if (val?.approval_status === "pending") {
                                  return (
                                    <>
                                      <div
                                        key={index}
                                        className="group flex flex-col drop-shadow-xl overflow-hidden"
                                      >
                                        <div
                                          className="w-4/5 antialiased truncate text-[#000000] text-sm font-semibold"
                                          style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            textTransform: "capitalize",
                                          }}
                                        >
                                          <Tooltip
                                            componentsProps={{
                                              popper: {
                                                sx: {
                                                  [`& .${tooltipClasses.tooltip}`]:
                                                    {
                                                      backgroundColor: (
                                                        theme
                                                      ) =>
                                                        theme.palette.common
                                                          .black,
                                                    },
                                                  [`& .${tooltipClasses.arrow}`]:
                                                    {
                                                      color: (theme) =>
                                                        theme.palette.common
                                                          .black,
                                                    },
                                                },
                                              },
                                            }}
                                            arrow
                                            PopperProps={{
                                              style: {
                                                maxWidth: "none",
                                                textTransform: "capitalize",
                                              },
                                            }}
                                            title={val?.name}
                                            placement="bottom-start"
                                          >
                                            {val?.name?.toLowerCase()}
                                          </Tooltip>
                                        </div>
                                        <div className="flex flex-row justify-between">
                                          <div className="flex flex-col space-y-1 text-left">
                                            <div className="text-base text-black antialiased">
                                              {val.pan_no}
                                              <br />
                                              <span className="text-xs text-[#828282]">
                                                PAN number
                                              </span>
                                            </div>
                                          </div>
                                          <div className="flex flex-row justify-end w-2/6 h-4">
                                            {/* <img
                                          src={require("../../../../assets/Banks/" +
                                            bankLogoMapper(val?.bank_name) +
                                            ".png")}
                                          alt="bank"
                                        /> */}
                                          </div>
                                        </div>
                                      </div>
                                      {index !== array.length - 1 && (
                                        <>
                                          <div className="border-t border-Primary_grey w-full mb-2"></div>
                                        </>
                                      )}
                                    </>
                                  );
                                }
                                return null;
                              })}
                          </div>
                        </>
                      )}
                    </div>
                  ) : (
                    <div className="w-full h-full flex flex-col justify-center items-center gap-5 text-center overflow-hidden">
                      <div className="w-[40%] flex flex-row justify-center">
                        <img className="max-w-[145%] pt-5" alt="NoDataImg" />
                      </div>
                      <div className="text-white text-lg antialiased">
                        <p>
                          No associated accounts found for the PAN details
                          provided
                          <br />
                          <span className="text-xs">
                            There are no existing accounts that are associated
                            with the PAN details provided.
                          </span>
                        </p>
                      </div>
                    </div>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeneCreateSuccess;
